export const visit = (vm, at) => {
at({ "id": { "conversationsVisitorUIAvailability": { "sameDay": "Kami akan kembali hari ini pada {{time}}", "nextDay": "Kami akan kembali besok pada {{time}}", "nextWeek": "Kami akan kembali {{dayOfWeek}} pada {{time}}" } } });
};